const get = require("lodash/get")
const qs = require("qs")

// Removes empty paragraphs from Kentico content
exports.cleanedText = (text) => {
  return text && text.replace(/(<p><br><\/p>|\n|\r)+/, "").trim()
}

// Divide an array into equal parts
exports.chunk = (array, numberOfChunks, balanced) => {
  if (numberOfChunks < 2) return [array]

  var length = array.length,
    out = [],
    i = 0,
    size

  if (length % numberOfChunks === 0) {
    size = Math.floor(length / numberOfChunks)
    while (i < length) {
      out.push(array.slice(i, (i += size)))
    }
  } else if (balanced) {
    while (i < length) {
      size = Math.ceil((length - i) / numberOfChunks--)
      out.push(array.slice(i, (i += size)))
    }
  } else {
    numberOfChunks--
    size = Math.floor(length / numberOfChunks)
    if (length % size === 0) size--
    while (i < size * numberOfChunks) {
      out.push(array.slice(i, (i += size)))
    }
    out.push(array.slice(size * numberOfChunks))
  }

  return out
}

exports.getQueryStringValue = (
  key,
  queryString = typeof window !== "undefined" ? window.location.search : ""
) => {
  let params = queryString.slice(1) // removes the first character, the `?`, from the query string
  let values = qs.parse(params)
  return values[key]
}

exports.urlHelper = (contentItem) => {
  let uri

  if (!contentItem) {
    console.error({ message: "Unhandled URL. No content item." })
    return
  }

  if (contentItem.system && contentItem.system.type === "link__external_") {
    return contentItem.elements.link_url.value
  }

  if (contentItem.system && contentItem.system.type === "modal") {
    return undefined
  }

  if (contentItem.resolved_url) {
    return contentItem.resolved_url
  } else {
    switch (
      contentItem.system && contentItem.system.type
        ? contentItem.system.type
        : "unhandled"
    ) {
      case "article":
        uri = `/media/news/${contentItem.elements.url_slug.value}`
        break
      case "belt_identifier_type":
        uri = `/belt-identifier/${contentItem.elements.url_slug.value}`
        break
      case "belt_series":
        const [beltType] = contentItem.elements.belt_type.value
        uri = `/belt-identifier${
          beltType && beltType.elements
            ? `/${beltType.elements.url_slug.value}`
            : ``
        }/${contentItem.elements.url_slug.value}`
        break
      case "case_study":
        uri = `/media/case-studies/${contentItem.elements.url_slug.value}`
        break
      case "contact_directory":
        uri = `/support/phone-numbers/${contentItem.elements.url_slug.value}`
        break
      case "industry":
        const [industry_group] = contentItem.elements.industry_group.value
        uri = `/industries${
          industry_group && industry_group.elements
            ? `/${industry_group.elements.url_slug.value}`
            : ``
        }/${contentItem.elements.url_slug.value}`
        break
      case "ind_group":
        uri = `/industries/${contentItem.elements.url_slug.value}`
        break
      case "page":
        const [parent_element] = contentItem.elements.parent_element.value
        uri = `${
          parent_element && parent_element.elements
            ? `/${parent_element.elements.url_slug.value}`
            : ``
        }/${contentItem.elements.url_slug.value}`
        break
      case "service":
        const [parent] = contentItem.elements.service_parent.value
        uri = `/solutions${
          parent && parent.elements ? `/${parent.elements.url_slug.value}` : ``
        }/${contentItem.elements.url_slug.value}`
        break
      case "shipping":
        uri = `/support/shipping/${contentItem.elements.url_slug.value}`
        break
      case "home":
        uri = `/`
        break
      default:
        console.error({ message: "Unhandled URL", contentItem })
    }
  }

  const internal = /^\/(?!\/)/.test(uri)
  const file = /\.[0-9a-z]+$/i.test(uri)

  if (internal && !file) {
    return (
      contentItem.preferred_language
        ? contentItem.preferred_language === "en"
        : contentItem.system.language === "en"
    )
      ? `${uri}`
      : `/${
          contentItem.preferred_language
            ? contentItem.preferred_language
            : contentItem.system.language
        }${uri}`
  } else {
    return uri
  }
}

exports.capitalizeFirstLetter = (string) =>
  string && string[0].toUpperCase() + string.substr(1)

exports.pageTypes = [
  "article",
  "post",
  "belt_identifier_type",
  "belt_series",
  "case_study",
  "case_studies_landing_page",
  "link__external_",
  "file",
  "home",
  "ind_group",
  "industries_landing_page",
  "industry",
  "landing_page",
  "product_group",
  "product_type",
  "products_landing_page",
  "page",
  "redirect",
  "service",
]

exports.doesTypeCreatePage = (type) =>
  module.exports.pageTypes.indexOf(type) !== -1

exports.getParentCodename = (node) => {
  switch (node.system.type) {
    case "belt_series":
      return get(node, "elements.belt_type.value[0]")
    case "case_studies_landing_page":
      return get(node, "elements.parent_element.value[0]")
    case "industry":
      return (
        get(node, "elements.industry_group.value[0]") ||
        "industries_landing_page"
      )
    case "ind_group":
      return "industries_landing_page"
    case "landing_page":
      return get(node, "elements.parent_element.value[0]")
    case "product_type":
      return get(node, "elements.product_group.value[0]")
    case "page":
      return get(node, "elements.parent_element.value[0]")
    case "redirect":
      return get(node, "elements.parent_element.value[0]")
    case "product_group":
      return "products_landing_page"
    case "service":
      // Check if a Service item has a parent entry, otherwise create a relation with the Solutions landing page
      return get(node, "elements.service_parent.value[0]") || "page_solutions"
    default:
      return null
  }
}
//strips whitespace out of phone numbers on the phone-numbers page. used for 'tel:' link.
exports.stripWhiteSpace = (string) => string.replace(/\s+/g, "")

// TODO: Gatsby to fix in future release
// Takes an input object and converts it into a string representation of its path and leaf value
// (Used to work around change to sort syntax in Gatsby 5)
function pathObjectToPathString(input) {
  const path = []
  let currentValue = input
  let leaf = undefined
  while (currentValue) {
    if (typeof currentValue === `object`) {
      const entries = Object.entries(currentValue)
      if (entries.length !== 1) {
        throw new Error(`Invalid field arg`)
      }
      for (const [key, value] of entries) {
        path.push(key)
        currentValue = value
      }
    } else {
      leaf = currentValue
      currentValue = undefined
    }
  }

  return {
    path: path.join(`.`),
    leaf,
  }
}

// TODO: Gatsby to fix in future release
// Converts the sort object received from a GQL query to the shape expected by `nodeModel`
exports.maybeConvertSortInputObjectToSortPath = function (args) {
  if (!args.sort) {
    return args
  }

  let sorts = args.sort
  if (!Array.isArray(sorts)) {
    sorts = [sorts]
  }

  const modifiedSort = {
    fields: [],
    order: [],
  }

  for (const sort of sorts) {
    const { path, leaf } = pathObjectToPathString(sort)
    modifiedSort.fields.push(path)
    modifiedSort.order.push(leaf)
  }

  return {
    ...args,
    sort: modifiedSort,
  }
}
